import "../components/utility/nanotemplate";

const CLASSNAME_SEARCH_HAS_VALUE = 'has-value';
const $searchUi = document.getElementById('PatchNotesSearchUI');
const tpl = document.getElementById('card-template')?.innerHTML;
const hubsiteTpl = document.getElementById('hubsite-template')?.innerHTML;

function hotFixList(notes) {
    return notes.map(note => `<li><a href="${note.page_link}">${note.title}</a></li>`).join('');
}

function hubsiteHTML(url) {
    return url ? hubsiteTpl.t({ url }) : '';
}

function escapeRegExp(str) {
    // inject escape ('\') before special characters
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function buildSanitizedQueryPhraseRegexStrict(query){
    // Strict: spaces must match spaces exactly
    query = (query || '').trim();
    if (!query) return null;
    return new RegExp(escapeRegExp(query), 'giu'); // g=all, i=case-insens, u=Unicode
}

function highlightText( string, element = document) {
    const regexPattern = buildSanitizedQueryPhraseRegexStrict(string);
    if (!regexPattern) return;

    const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT, // only text nodes
        {
            acceptNode(node) {
                // Skip empty/whitespace-only nodes
                if (!node.nodeValue || !node.nodeValue.trim()) {
                    return NodeFilter.FILTER_REJECT;
                }
                // Skip text that lives inside disallowed ancestors (or already marked)
                const p = node.parentNode;
                if (!p) return NodeFilter.FILTER_REJECT;
                if (p.closest('mark,script,style,template,noscript,textarea')) {
                    return NodeFilter.FILTER_REJECT;
                }
                // only return the accepted node(s)
                return NodeFilter.FILTER_ACCEPT;
            }
        }
    );

    // Iterate text nodes; cache the next node before we replace the current one
    for (let node = walker.nextNode(); node; ) {
        const next = walker.nextNode();

        const text = node.nodeValue;
        regexPattern.lastIndex = 0; // important when using /g
        if (!regexPattern.test(text)) {
            // any match?
            node = next;
            continue;
        }

        // hold the changes in a document fragment to minimize reflows
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        regexPattern.lastIndex = 0;

        let match;

        // do the highlighting (wraps text with <mark>)
        while ((match = regexPattern.exec(text)) !== null) {
            const index = match.index;
            if (index > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, index)));
            }
            const mark = document.createElement('mark');
            mark.textContent = match[0]; // preserve original casing
            fragment.appendChild(mark);
            lastIndex = index + match[0].length;
        }
        if (lastIndex < text.length) {
            fragment.appendChild (document.createTextNode( text.slice(lastIndex) ) );
        }

        node.parentNode.replaceChild(fragment, node);
        node = next;
    }
}

function scheduleCallback( callback ) {
    const schedule = window.requestIdleCallback || (_callback => setTimeout(_callback, 0));
    schedule(() => {
        callback();
    });
}

function initSearchUi() {

    let $searchBarUi = $searchUi.querySelector( '.BuildnotesPageSearchBar' ),
        $searchInput = $searchUi.querySelector( 'input[name="query"]' ),
        $platformSelect = document.getElementById( 'BuildnotesPagePlatform'),
        $platformInput = $searchUi.querySelector( 'input[name="platform"]' );

    $platformSelect.onchange = ( event ) => {
        // if ( $platformInput.value === $platformSelect.value ) {
        //     return;
        // }
        // $platformInput.value = $platformSelect.value;

        $searchUi.requestSubmit();
    };

    $searchUi.addEventListener('click', function (event) {
        let $target = event.target.closest( 'button.close' );
        // console.log( { $target } );
        if ( $target ) {
            if ( $searchInput ) $searchInput.value = '';
            // $searchUi.requestSubmit();
            $searchBarUi.classList.remove( CLASSNAME_SEARCH_HAS_VALUE );
        }
    });

    $searchInput.addEventListener('input', (event) => {
        // console.log( 'Input', { event, 'value': $searchInput.value, 'data': event.data } );
        if( event.target.value.length ) {
            $searchBarUi.classList.add( CLASSNAME_SEARCH_HAS_VALUE );
        } else {
            $searchBarUi.classList.remove( CLASSNAME_SEARCH_HAS_VALUE );
        }
    });
}

function createLoadMoreHandler({ btnId, containerSelector, endpointBuilder, onData }) {
    const btn = document.getElementById(btnId);
    const container = document.querySelector(containerSelector);
    if (!btn || !container) return;

    let page = 1;

    btn.addEventListener('click', async () => {
        const url = endpointBuilder(++page);

        try {
            const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!res.ok) return console.error('[loadMore] HTTP error', res.status);

            const data = await res.json();
            const hasMore = await onData(data, container);

            if (!hasMore) {
                (btn.closest('.LoadMoreWrap') || btn.parentElement).style.display = 'none';
            }
        } catch (e) {
            console.error('[loadMore] fetch failed', e);
        }
    });
}


function initSearchLoadMoreUnified() {
    createLoadMoreHandler({
        btnId: 'load-more-search',
        containerSelector: '#search-results',
        endpointBuilder: (page) => {
            const btn = document.getElementById('load-more-search');
            const platform = btn.dataset.platform || 'pc';
            const query = btn.dataset.query || '';
            const locale = document.documentElement.lang || 'en';
            return `/${locale}/patch-notes/search/json?platform=${encodeURIComponent(platform)}&query=${encodeURIComponent(query)}&page=${page}`;
        },
        onData: async ({ html, hasMore }, container) => {
            if (html) container.insertAdjacentHTML('beforeend', html);
            return hasMore;
        }
    });
}

function initDefaultLoadMore() {
    createLoadMoreHandler({
        btnId: 'load-more',
        containerSelector: '#patch-notes .directory',
        endpointBuilder: (page) => {
            const platform = document.getElementById('load-more')?.dataset.platform || 'pc';
            const locale = document.documentElement.lang || 'en';
            return `/${locale}/patch-notes/${encodeURIComponent(platform)}/json?page=${page}`;
        },
        onData: async ({ groupedNotes, hasMore }, container) => {
            groupedNotes.forEach(group => {
                const data = {
                    main_link: group.main.page_link,
                    main_image: group.main.image || "https://www-static.warframe.com/images/buildnotes/hotfix-large.jpg",
                    main_platform: group.main.platform,
                    main_title: group.main.title,
                    main_date: group.main.release_date,
                    main_hubsite: hubsiteHTML(group.main?.hubsite_url),
                    notes_list: hotFixList(group.notes)
                };
                container.insertAdjacentHTML('beforeend', tpl.t(data));
            });
            return hasMore;
        }
    });
}

function init() {
    if ($searchUi) initSearchUi();
    initDefaultLoadMore();
    initSearchLoadMoreUnified();

    if (window?.PatchNotes?.query) {
        scheduleCallback(() => {
            highlightText(window.PatchNotes.query, document.querySelector('#detail .record'));
        });
    }
}

// Run when the DOM is ready
// Check if `window.onload` has already fired
if (document.readyState === "complete") {
    init(); // Page is already fully loaded, run immediately
} else {
    window.onload = init; // Otherwise, wait for `window.onload`
}
